export const SHARE_TOAST_TIMEOUT_MILLIS = 1500
export const NEW_WALLET_CONNECTED_TOAST_TIMEOUT_MILLIS = 3000
export const CLAIM_REWARD_TOAST_TIMEOUT_MILLIS = 3000

export const STATIC_EXPLORE_CONTENT_URL =
  'https://download.audius.co/static-resources/explore-content.json'

export const NUM_FEED_TIPPERS_DISPLAYED = 2
